
import { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      {/* Top Bar */}
      <div className="bg-blue-600 text-white py-2">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center space-x-4">
            <span className="flex items-center">
              <i className="ri-phone-line mr-2"></i>
              (19) 3852-8200
            </span>
            <span className="flex items-center">
              <i className="ri-mail-line mr-2"></i>
              contato@sustentare.com.br
            </span>
          </div>
          <div className="flex items-center space-x-4">
            <a href="https://www.facebook.com/sustentare.brasil" target="_blank" rel="noopener noreferrer" className="hover:text-blue-200 transition-colors">
              <i className="ri-facebook-fill"></i>
            </a>
            <a href="https://www.instagram.com/sustentarealimentos" target="_blank" rel="noopener noreferrer" className="hover:text-blue-200 transition-colors">
              <i className="ri-instagram-fill"></i>
            </a>
            <a href="https://www.youtube.com/user/tecnutrifoodservice" target="_blank" rel="noopener noreferrer" className="hover:text-blue-200 transition-colors">
              <i className="ri-youtube-fill"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/18c945fe109fcaa4776e00cd4097bc6c.png" 
              alt="Sustentare Logo" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Home
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Sobre
            </Link>
            <Link to="/mission-vision-values" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Missão, Visão e Valores
            </Link>
            <Link to="/noticias" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Notícias
            </Link>
            <Link to="/enjoy" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Enjoy
            </Link>
            <Link to="/nutrare" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Nutrare
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-700 hover:text-blue-600 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-lg py-4 px-4 space-y-4">
            <Link 
              to="/" 
              className="block text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className="block text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              Sobre
            </Link>
            <Link 
              to="/mission-vision-values" 
              className="block text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              Missão, Visão e Valores
            </Link>
            <Link 
              to="/noticias" 
              className="block text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              Notícias
            </Link>
            <Link 
              to="/enjoy" 
              className="block text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              Enjoy
            </Link>
            <Link 
              to="/nutrare" 
              className="block text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              Nutrare
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
